import { render, staticRenderFns } from "./FileBrowserButton.vue?vue&type=template&id=2d2ebc28&scoped=true&"
import script from "./FileBrowserButton.vue?vue&type=script&lang=js&"
export * from "./FileBrowserButton.vue?vue&type=script&lang=js&"
import style0 from "./FileBrowserButton.vue?vue&type=style&index=0&id=2d2ebc28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ebc28",
  null
  
)

export default component.exports